export default __webpack_public_path__ + "static/doctor-0f736a77875f36d5d19070f8e6c95cd6.png";